/**
 * 模块: 品牌详情表格列定义
 * 职责: 定义品牌详情表格的动态列配置
 * 限制: <130行
 */

import React from 'react';
import { Tag, Progress } from 'antd';
import type { ColumnsType } from 'antd/es/table';

export const getBrandDetailsColumns = (brandDetails: any[]): ColumnsType<any> => [
  {
    title: '排名',
    key: 'rank',
    fixed: 'left',
    width: 70,
    render: (_: any, __: any, index: number) => (
      <Tag color="blue">#{index + 1}</Tag>
    ),
  },
  {
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand',
    fixed: 'left',
    width: 150,
    render: (text: string) => <strong>{text}</strong>,
  },
  {
    title: '市场影响力',
    dataIndex: 'market_influence',
    key: 'market_influence',
    width: 180,
    sorter: (a: any, b: any) => a.market_influence - b.market_influence,
    defaultSortOrder: 'descend',
    render: (val: number) => {
      const maxInfluence = Math.max(...brandDetails.map((b: any) => b.market_influence || 0));
      const percentage = maxInfluence > 0 ? (val / maxInfluence) * 100 : 0;
      return (
        <div>
          <div style={{ marginBottom: 4 }}>
            <span style={{ fontWeight: 'bold' }}>{val.toFixed(2)}</span>
          </div>
          <Progress
            percent={percentage}
            showInfo={false}
            strokeColor={{
              '0%': '#108ee9',
              '100%': '#87d068',
            }}
            size="small"
          />
        </div>
      );
    },
  },
  {
    title: '覆盖关键词数',
    dataIndex: 'keyword_count',
    key: 'keyword_count',
    width: 120,
    sorter: (a: any, b: any) => a.keyword_count - b.keyword_count,
    render: (val: number) => <Tag color="blue">{val}</Tag>,
  },
  {
    title: 'Top1出现次数',
    dataIndex: 'top1_count',
    key: 'top1_count',
    width: 120,
    sorter: (a: any, b: any) => a.top1_count - b.top1_count,
    render: (val: number) => <Tag color="gold">{val}</Tag>,
  },
  {
    title: '转化效率',
    dataIndex: 'conversion_efficiency',
    key: 'conversion_efficiency',
    width: 120,
    sorter: (a: any, b: any) => a.conversion_efficiency - b.conversion_efficiency,
    render: (val: number) => (
      <Tag color={val > 1 ? 'green' : val > 0.8 ? 'orange' : 'red'}>
        {val.toFixed(4)}
      </Tag>
    ),
  },
  {
    title: '平均搜索排名',
    dataIndex: 'avg_search_rank',
    key: 'avg_search_rank',
    width: 120,
    sorter: (a: any, b: any) => a.avg_search_rank - b.avg_search_rank,
    render: (val: number) => val.toFixed(2),
  },
  {
    title: '平均点击份额 (%)',
    dataIndex: 'avg_click_share',
    key: 'avg_click_share',
    width: 140,
    sorter: (a: any, b: any) => a.avg_click_share - b.avg_click_share,
    render: (val: number) => `${val.toFixed(2)}%`,
  },
  {
    title: '平均转化份额 (%)',
    dataIndex: 'avg_conv_share',
    key: 'avg_conv_share',
    width: 140,
    sorter: (a: any, b: any) => a.avg_conv_share - b.avg_conv_share,
    render: (val: number) => `${val.toFixed(2)}%`,
  },
];

